import type { ItemDto as LocalItemDto } from '../services/graphql.types'
import type { ControllerType } from '../types/ControllerType'
import { type ProductType, useAddToCart } from './mutations/useAddToCart'
import { useNotificationHandler } from './useNotificationHandler'

interface CartControllerProps {
	isCartPage: boolean
}

export const useCartController = ({
	isCartPage,
}: CartControllerProps): ControllerType => {
	const { addItem } = useAddToCart(isCartPage)
	const { handleNotification } = useNotificationHandler()

	const addItemWithNotification = async (
		product: ProductType,
		location: string,
		productListId?: string,
		productListName?: string
	) => {
		const response = await addItem(
			product,
			location,
			productListId,
			productListName
		)

		const foundItem = response?.addItem?.items?.find(
			(currentItem) =>
				currentItem?.colorId === product.colorId &&
				currentItem?.sizeId === product.sizeId &&
				currentItem?.productId === product.productId
		)

		if (!foundItem) {
			return null
		}

		const cartItems: LocalItemDto[] =
			response?.addItem?.items?.filter(
				(i): i is LocalItemDto => i !== null && i !== undefined
			) ?? []

		handleNotification({
			cartItems,
			location,
			item: foundItem,
		})

		return foundItem
	}

	return {
		add: async (product, location, productListId, productListName) => {
			try {
				await addItemWithNotification(
					product,
					location,
					productListId,
					productListName
				)
			} catch (error) {
				console.error('Error adding product:', error)
			}
		},
		addWithoutNotification: async (
			product,
			location,
			productListId,
			productListName
		) => {
			try {
				await addItem(product, location, productListId, productListName)
			} catch (error) {
				console.error('Error adding product:', error)
			}
		},
	}
}
